import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.debounceTimer = null
  }

  search(event) {
    const query = event.target.value
    clearTimeout(this.debounceTimer)

    this.debounceTimer = setTimeout(() => {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("search", query)
      const frame = document.getElementById("companies_list")
      if (frame) frame.src = url.toString()
    }, 300)
  }
}
